import { Button, capitalize, Card, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getList, ProcessFile } from '../../redux/api/system'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput'
import { Edit, Upload } from '@mui/icons-material'
import DocumentInput from '../../components/common/DocumentInput'
import DialogBox from '../../components/common/DialogBox'

const UploadDataset = () => {
    const [ showModal, setShowModal ] = useState(false)
    const [ selectedUser, setSelectedUser ] = useState(null);
    const [ users, setUsers ] = useState([]);
    const [ datasets, setDatasets ] = useState([]);
    const [ domains, setDomains ] = useState([]);
    const [ responseModal, setResponseModal ] = useState(false);
    const [ responseStatus, setResponseStatus ] = useState(false);
    const [ responseContent, setResponseContent ] = useState("");
    const { enqueueSnackbar } = useSnackbar();

    const defaultUser = {
        "name": "",
        "userID": "",
        "email": "",
        "password": "",
        "roleID": "",
        "active": true,
        "institutionID": ""
    }

    const getDomains = async () => {
        try {
            const resp = await getList("file_datasets");
            const respDomain = await getList("domains");
            setDomains(respDomain?.listing || [])

            if(resp?.responseCode === "00") {
                setDatasets(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    const uploadFile = async (values, { resetForm }) => {
        try {
            const formData = new FormData();
            formData.append('target', values.target);
            formData.append('file', values.file);

            const resp = await ProcessFile(formData);
            if(resp?.responseCode === "00") {
                enqueueSnackbar('Action performed successfully')
                setShowModal(true)
                resetForm()
            } else {
                setResponseStatus(false);
                setResponseContent(String(resp?.message || resp?.responseMessage || 'An error occurred'));
                setResponseModal(true);
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    useEffect(() => {
        getDomains()
    }, [])

    return (
        <PageContainer pageTitle='Users'>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">Upload</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Dataset</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 mt-4'>
                            <Card style={{ padding: '3rem 4rem', width: '100%', textAlign: 'center' }}>
                                <Formik enableReinitialize initialValues={{ file: '', category: '' }} onSubmit={uploadFile}>
                                    {({ isSubmitting, values, setFieldValue }) => (
                                        <Form>
                                            <h3 className='text-bold mt-05' >New Dataset Upload</h3>
                                            <Divider className="mt-05 mb-2" />
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <SelectInput options={datasets} id="target" field="id" fieldDisplay="dataSetName" required label="Select Target Datasets" 
                                                        customChange={(name, value) => {
                                                            const dataset = datasets?.find(({ id }) => id == value);
                                                            if(dataset) {
                                                                setFieldValue('domainID', dataset?.domainID)
                                                                setFieldValue('type', dataset?.type)
                                                                setFieldValue('ingestMedium', dataset?.ingestMedium)
                                                                setFieldValue('frequency', dataset?.frequency)
                                                                setFieldValue('deliveryMedium', dataset?.deliveryMedium)                                                                
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                {
                                                    values?.target && 
                                                    <>
                                                        <Grid item xs={12} md={6}>
                                                            <SelectInput options={domains} id="domainID" field="domainID" fieldDisplay="domainName" required label="Domain" readOnly />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextInput id="ingestMedium" value={capitalize(values?.ingestMedium || '')} required label="Ingest Medium" readOnly />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextInput id="deliveryMedium" value={capitalize(values?.deliveryMedium || '')} required label="Delivery Medium" readOnly />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextInput id="frequency" required label="Frequency" value={capitalize(values?.frequency || '')} readOnly />
                                                        </Grid>
                                                    </>
                                                }
                                                <Grid item xs={12}>
                                                    <DocumentInput required id="file" label="Dataset File" />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Button type='submit' variant="contained" disabled={isSubmitting} startIcon={<Upload />}>
                                                        {
                                                            isSubmitting ?
                                                            <CircularProgress size={15} color="inherit" />
                                                            :
                                                            'Upload File'
                                                        }
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Form>
                                    )}
                                </Formik>
                            </Card>
                        </div>
                        {/* Dialog Box for request responses */}
                        <DialogBox isIconTitle content={responseContent} responseType={responseStatus} opener={responseModal} closer={setResponseModal} />
                    </div>
                </div>
            </div>

            <Dialog open={showModal}>
                <DialogContent>
                    <h3 className='text-bold' >File uploaded successfully</h3>
                </DialogContent>
                <DialogActions className='pr-2 pb-2'>
                    <Button variant="contained" onClick={() => setShowModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>

        </PageContainer>
    )
}

export default UploadDataset